var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantaveragesviewSideicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6834 8.0166H10.3083C9.96668 8.0166 9.68335 7.73327 9.68335 7.3916C9.68335 7.04993 9.96668 6.7666 10.3083 6.7666H14.6834C15.025 6.7666 15.3084 7.04993 15.3084 7.3916C15.3084 7.73327 15.0334 8.0166 14.6834 8.0166Z",
    fill: "#909AB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93334 8.64977C5.77501 8.64977 5.61667 8.59144 5.49167 8.46644L4.86667 7.84144C4.62501 7.59977 4.62501 7.19977 4.86667 6.95811C5.10834 6.71644 5.50834 6.71644 5.75001 6.95811L5.93334 7.14144L7.36667 5.70811C7.60834 5.46644 8.00834 5.46644 8.25001 5.70811C8.49167 5.94977 8.49167 6.34977 8.25001 6.59144L6.37501 8.46644C6.25834 8.58311 6.10001 8.64977 5.93334 8.64977Z",
    fill: "#909AB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6834 13.8501H10.3083C9.96668 13.8501 9.68335 13.5668 9.68335 13.2251C9.68335 12.8834 9.96668 12.6001 10.3083 12.6001H14.6834C15.025 12.6001 15.3084 12.8834 15.3084 13.2251C15.3084 13.5668 15.0334 13.8501 14.6834 13.8501Z",
    fill: "#909AB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93334 14.4833C5.77501 14.4833 5.61667 14.4249 5.49167 14.2999L4.86667 13.6749C4.62501 13.4333 4.62501 13.0333 4.86667 12.7916C5.10834 12.5499 5.50834 12.5499 5.75001 12.7916L5.93334 12.9749L7.36667 11.5416C7.60834 11.2999 8.00834 11.2999 8.25001 11.5416C8.49167 11.7833 8.49167 12.1833 8.25001 12.4249L6.37501 14.2999C6.25834 14.4166 6.10001 14.4833 5.93334 14.4833Z",
    fill: "#909AB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.9582H7.50002C2.97502 18.9582 1.04169 17.0248 1.04169 12.4998V7.49984C1.04169 2.97484 2.97502 1.0415 7.50002 1.0415H12.5C17.025 1.0415 18.9584 2.97484 18.9584 7.49984V12.4998C18.9584 17.0248 17.025 18.9582 12.5 18.9582ZM7.50002 2.2915C3.65835 2.2915 2.29169 3.65817 2.29169 7.49984V12.4998C2.29169 16.3415 3.65835 17.7082 7.50002 17.7082H12.5C16.3417 17.7082 17.7084 16.3415 17.7084 12.4998V7.49984C17.7084 3.65817 16.3417 2.2915 12.5 2.2915H7.50002Z",
    fill: "#909AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantaveragesviewSideicon);
export default __webpack_public_path__ + "static/media/Plant averages view - side icon.6520baf45a47c79f139617ae630ee83c.svg";
export { ForwardRef as ReactComponent };